import axios from 'axios';
import { common, routes } from '@constants';
import { storage } from '@utils';

const options = {
  baseURL: common.BASE_URL,
};

// Extract tenant slug from subdomain: admin.boredbrewing.ordo.menu → boredbrewing
function getTenantSlug() {
  const parts = window.location.hostname.split('.');
  // Pattern: admin.{slug}.ordo.menu
  if (parts.length === 4 && parts[0] === 'admin' && parts[2] === 'ordo' && parts[3] === 'menu') {
    return parts[1];
  }
  return null;
}

const tokenHeaderInterceptor = config => {
  const token = storage.getToken();
  const tenantSlug = getTenantSlug();

  const configWithTokenHeader = {
    ...config,
    headers: {
      ...config.headers,
      token: token || '',
      ...(tenantSlug ? { 'x-tenant-slug': tenantSlug } : {}),
    },
  };

  return configWithTokenHeader;
};

const successInterceptor = response => response;

const errorInterceptor = error => {
  const { status } = error.response;

  if (status === common.UNAUTHORIZED) {
    storage.clear();
    window.location.href = routes.login;
  }

  return Promise.reject(error);
};

const requestUnauthorizedInterceptor = config => {
  const tenantSlug = getTenantSlug();
  if (tenantSlug) {
    config.headers = { ...config.headers, 'x-tenant-slug': tenantSlug };
  }
  return config;
};

const successUnauthorizedInterceptor = response => response;

const errorUnauthorizedInterceptor = error => Promise.reject(error);

const authorized = axios.create(options);
authorized.interceptors.request.use(tokenHeaderInterceptor);
authorized.interceptors.response.use(successInterceptor, errorInterceptor);

const unauthorized = axios.create(options);
unauthorized.interceptors.request.use(requestUnauthorizedInterceptor);
unauthorized.interceptors.response.use(successUnauthorizedInterceptor, errorUnauthorizedInterceptor);

export default {
  authorized,
  unauthorized,
};
